import React, { useRef, useEffect } from "react";

export default function LocationForm({ location, reason, onChangeLocation, onChangeReason, isEditing=true }) {
  const set = (k, v) => onChangeLocation({ ...location, [k]: v });
  const reasonRef = useRef(null);

  const adjustTextareaHeight = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleReasonChange = (event) => {
    onChangeReason({ ReasonforAppointment: event.target.value });
    adjustTextareaHeight(event.target);
  };

  useEffect(() => {
    adjustTextareaHeight(reasonRef.current);
  }, [reason.ReasonforAppointment]);

  return (
    <div className="cn-card">
      <h3>📍 Location</h3>
      <div className="row">
        <div>
          <label>
            <span style={{ marginRight: 8 }}>🏥</span>
            Location
          </label>
          <input 
            value={location.location || ""} 
            onChange={(e) => set("location", e.target.value)} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>📌</span>
            Address
          </label>
          <input 
            value={location.location2 || ""} 
            onChange={(e) => set("location2", e.target.value)} 
            disabled={!isEditing}
          />
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>📞</span>
            Ph/Fax
          </label>
          <input 
            value={location.location1 || ""} 
            onChange={(e) => set("location1", e.target.value)} 
            disabled={!isEditing}
          />
        </div>
      </div>
      
      <div style={{ marginTop: 8 }}>
        <label>
          <span style={{ marginRight: 8 }}>📝</span>
          Reason for Appointment
        </label>
        <textarea
          ref={reasonRef}
          value={reason.ReasonforAppointment || ""}
          onChange={handleReasonChange}
          style={{
            width: "100%",
            minHeight: "40px",
            overflow: "hidden",
            resize: "none",
            boxSizing: "border-box"
          }}
          disabled={!isEditing}
        />
      </div>
    </div>
  );
}